type SubscriptionStatusFields = {
  status: string
  cancel_requested_at?: string | null
  cancel_requested_at_formatted?: string | null
}

export type SubscriptionDisplayStatusKey =
  | 'cancel_requested'
  | 'pending'
  | 'active'
  | 'past_due'
  | 'suspended'
  | 'canceled'
  | 'expired'

export function resolveSubscriptionDisplayStatusKey(
  subscription: SubscriptionStatusFields,
): SubscriptionDisplayStatusKey {
  if (
    subscription.cancel_requested_at
    || subscription.cancel_requested_at_formatted
  ) {
    return 'cancel_requested'
  }

  const status = subscription.status as SubscriptionDisplayStatusKey

  if (
    status === 'pending'
    || status === 'active'
    || status === 'past_due'
    || status === 'suspended'
    || status === 'canceled'
    || status === 'expired'
  ) {
    return status
  }

  return 'active'
}

export function resolveSubscriptionDisplayStatus(
  subscription: SubscriptionStatusFields,
  translate: (key: string) => string,
): { status: string; text: string } {
  const displayKey = resolveSubscriptionDisplayStatusKey(subscription)

  return {
    status: displayKey === 'cancel_requested' ? subscription.status : displayKey,
    text: translate(displayKey),
  }
}
